<script setup>
import StormCenter from '@/components/StormCenter.vue';

</script>

<template>
  <Suspense>
    <StormCenter />
  </Suspense>
</template>
